export default __webpack_public_path__ + "static/media/graphql.97120526.png";